import { useState } from 'owa-react';
import React from 'react';
import {
    Button,
    type OnOpenChangeData,
    Popover,
    PopoverSurface,
    PopoverTrigger,
} from '@fluentui/react-components';
import { GridDotsFilled } from '@fluentui/react-icons';
import { isCapabilityEnabled } from 'owa-capabilities';
import { headerFullBleedCapability } from 'owa-capabilities-definitions/lib/headerFullBleedCapability';
import { headerAppLauncherCapability } from 'owa-capabilities-definitions/lib/headerAppLauncherCapability';
import classNames from 'owa-classnames';
import { LazyOwaHeaderAppLauncherContent } from 'owa-header-applauncher';
import loc from 'owa-localize';
import { observer } from 'owa-mobx-react';
import type NavBarData from 'owa-service/lib/contract/NavBarData';
import { APP_LAUNCHER_BUTTON_ID } from '../../constants/constants';
import { activeButton, headerButton, buttonFullBleed } from '../buttons/OwaHeaderButtonGroup.scss';
import { appLauncherButtonLabel } from '../OwaHeader.locstring.json';
import { appLauncherSurface } from '../OwaHeader.scss';

const buttonIcon = <GridDotsFilled />;

interface OwaHeaderAppLauncherProps {
    buttonRef: React.Ref<HTMLButtonElement>;
    navBarData: NavBarData | null;
}

const defaultExport: React.FunctionComponent<OwaHeaderAppLauncherProps> = observer(
    function OwaHeaderAppLauncher(props) {
        const { buttonRef, navBarData } = props;

        const [isOpen, setIsOpen] = useState(false);

        const onOpenChange = React.useCallback((_: any, data: OnOpenChangeData) => {
            setIsOpen(data.open);
        }, []);

        if (!isCapabilityEnabled(headerAppLauncherCapability)) {
            return null;
        }

        return (
            <Popover open={isOpen} onOpenChange={onOpenChange}>
                <PopoverTrigger disableButtonEnhancement={false}>
                    <Button
                        id={APP_LAUNCHER_BUTTON_ID}
                        ref={buttonRef}
                        icon={buttonIcon}
                        aria-label={loc(appLauncherButtonLabel)}
                        className={classNames(
                            headerButton,
                            isCapabilityEnabled(headerFullBleedCapability) && buttonFullBleed,
                            isOpen && activeButton
                        )}
                    />
                </PopoverTrigger>
                <PopoverSurface className={appLauncherSurface} tabIndex={-1}>
                    <LazyOwaHeaderAppLauncherContent navBarData={navBarData} />
                </PopoverSurface>
            </Popover>
        );
    },
    'OwaHeaderAppLauncher'
);

export default defaultExport;
